module.exports = __webpack_public_path__ + "img/Artboard7.1f64282a.webp";